import React from 'react';
import './Process.css';
  
  const Process = () =>  {
	return (
	  <>
      <div className='process-container'>
        <div className='process-section-1'>
        <p className='section-highlight'>The Process</p>
        <h1 className='section-heading'>How It Works</h1>
        </div>
        <div className='process-section-2'>
            <div className='process-card-1'>
                <div className='process-card-1-child'>
                    <h2> <span className='process-num'>1</span>Account Registration</h2>
                    <p>Sign up effortlessly and get access to a user-friendly trading dashboard</p>
                </div>
                <div className='process-card-1-child'>
                    <h2> <span className='process-num'>2</span>Deposit Funds</h2>
                    <p>Deposit with ease and take control of your trades instantly</p>
                </div>
                <div className='process-card-1-child'>
                    <h2> <span className='process-num'>3</span>Start Trading</h2>
                    <p>Explore markets, analyze trends, and start trading with confidence.</p>
                </div>
            </div>
            <div className='process-card-2'></div>
        </div>
      </div>
	  </>
	);
  }
  
  export default Process;
  